import BasePanel from "./base-panel";
export default BasePanel;
